/**
 * RIM nested routes.
 *
 * `:planNumber` renders the read + beneficiary view; the four operational
 * flows live as sub-routes so Back-button behaviour and deep-linking both
 * work cleanly:
 *   /rim/:planNumber/contribution
 *   /rim/:planNumber/distribution
 *   /rim/:planNumber/rmd
 *   /rim/:planNumber/rollover
 */
import { Routes, Route } from 'react-router';
import { RimLanding } from './RimLanding';
import { PlanDetail } from './PlanDetail';
import { ContributionFlow } from './flows/ContributionFlow';
import { DistributionFlow } from './flows/DistributionFlow';
import { RmdWithdrawalFlow } from './flows/RmdWithdrawalFlow';
import { RolloverFlow } from './flows/RolloverFlow';
import { RecurringContributionFlow } from './flows/RecurringContributionFlow';
import { TransferOutFlow } from './flows/TransferOutFlow';
import { InHouseTransferFlow } from './flows/InHouseTransferFlow';

export function RimRoutes(): JSX.Element {
  return (
    <Routes>
      <Route index element={<RimLanding />} />
      <Route path=":planNumber" element={<PlanDetail />} />
      <Route path=":planNumber/contribution" element={<ContributionFlow />} />
      <Route path=":planNumber/recurring-contribution" element={<RecurringContributionFlow />} />
      <Route path=":planNumber/distribution" element={<DistributionFlow />} />
      <Route path=":planNumber/rmd" element={<RmdWithdrawalFlow />} />
      <Route path=":planNumber/rollover" element={<RolloverFlow />} />
      <Route path=":planNumber/transfer-out" element={<TransferOutFlow />} />
      <Route path=":planNumber/transfer-internal" element={<InHouseTransferFlow />} />
      <Route path="*" element={<RimLanding />} />
    </Routes>
  );
}
